import { render, staticRenderFns } from "./reisetermin-card-vorgaenge-transfer.vue?vue&type=template&id=b66149c8&scoped=true"
import script from "./reisetermin-card-vorgaenge-transfer.vue?vue&type=script&lang=js"
export * from "./reisetermin-card-vorgaenge-transfer.vue?vue&type=script&lang=js"
import style0 from "./reisetermin-card-vorgaenge-transfer.vue?vue&type=style&index=0&id=b66149c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b66149c8",
  null
  
)

export default component.exports